import { DestinationPresetKey } from 'blocks/DestinationPlatforms';

export const VIDEO_WIZARD_VIDEO_TYPES_BLACKLIST: DestinationPresetKey[] = [
  'FacebookEpisode',
];
